
const RightArrowIcon = ({ color = "#175CD3" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M5.25 11L8.75 7.5L5.25 4" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default RightArrowIcon